var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from './api'; // Importa a instância configurada
import { getHeader } from './header';
// Função para registrar acesso
var registerAccess = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, getHeader()];
            case 1:
                header = _b.sent();
                return [4 /*yield*/, api.post('/access', {}, header)];
            case 2:
                _b.sent();
                return [3 /*break*/, 4];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var getPlatformsData = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                // Não espera o registerAccess terminar, apenas dispara
                registerAccess();
                return [2 /*return*/, api.get('/platforms', header)];
        }
    });
}); };
// Google APIs
export var checkGoogleConnection = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get('/platforms/google-connection-status', header)]; // Usa a instância configurada
        }
    });
}); };
export var getGoogleAccounts = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get('/platforms/google-accounts', header)]; // Usa a instância configurada
        }
    });
}); };
export var getGoogleProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get('/platforms/google-profile', header)];
        }
    });
}); };
export var handleGoogleLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header, response, authUrl, popup, allowedOrigins_1, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, api.get('/platforms/auth/google', header)];
            case 3:
                response = _a.sent();
                authUrl = response.data.auth_url;
                popup = window.open(authUrl, 'Conectar Google Ads', 'width=500,height=800');
                if (popup) {
                    allowedOrigins_1 = [
                        'http://localhost:8080',
                        'http://localhost:8000',
                        'https://www.visioncockpit.com.br'
                    ];
                    // Ouve mensagens da pop-up
                    window.addEventListener('message', function (event) {
                        if (!allowedOrigins_1.includes(event.origin)) {
                            console.error('Origem não permitida:', event.origin);
                            return;
                        }
                        if (event.data === 'google-auth-success') {
                            // console.log('Autenticação do Google concluída com sucesso.');
                            window.location.reload(); // Atualiza a página
                        }
                    });
                }
                return [3 /*break*/, 5];
            case 4:
                error_1 = _a.sent();
                console.error('Erro ao obter a URL de autenticação do Google:', error_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var handleGoogleLoginMobile = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header, response, authUrl, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, api.get('/platforms/auth/google', header)];
            case 3:
                response = _a.sent();
                authUrl = response.data.auth_url;
                // Mobile: redireciona a página inteira para o fluxo de autenticação
                window.location.href = authUrl;
                return [3 /*break*/, 5];
            case 4:
                error_2 = _a.sent();
                console.error('Erro ao obter a URL de autenticação do Google:', error_2);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var logoutGoogle = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.post('/platforms/logout/google', {}, header)];
        }
    });
}); };
// Facebook APIs
export var checkFacebookConnection = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get('/platforms/facebook-connection-status', header)]; // Usa a instância configurada
        }
    });
}); };
export var getFacebookAccounts = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get('/platforms/facebook-accounts', header)]; // Usa a instância configurada
        }
    });
}); };
export var getFacebookProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get('/platforms/facebook-profile', header)];
        }
    });
}); };
export var handleFacebookLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header, response, authUrl, popup, allowedOrigins_2, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, api.get('/platforms/auth/facebook', header)];
            case 3:
                response = _a.sent();
                authUrl = response.data.auth_url;
                popup = window.open(authUrl, 'Conectar Facebook Ads', 'width=600,height=800');
                if (popup) {
                    allowedOrigins_2 = [
                        'http://localhost:8080',
                        'http://localhost:8000',
                        'https://www.visioncockpit.com.br'
                    ];
                    // Ouve mensagens da pop-up
                    window.addEventListener('message', function (event) {
                        if (!allowedOrigins_2.includes(event.origin)) {
                            console.error('Origem não permitida:', event.origin);
                            return;
                        }
                        if (event.data === 'facebook-auth-success') {
                            // console.log('Autenticação do Facebook concluída com sucesso.');
                            window.location.reload(); // Atualiza a página
                        }
                    });
                }
                return [3 /*break*/, 5];
            case 4:
                error_3 = _a.sent();
                console.error('Erro ao obter a URL de autenticação do Facebook:', error_3);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var handleFacebookLoginMobile = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header, response, authUrl, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, api.get('/platforms/auth/facebook', header)];
            case 3:
                response = _a.sent();
                authUrl = response.data.auth_url;
                // Mobile: redireciona a página inteira para o fluxo de autenticação
                window.location.href = authUrl;
                return [3 /*break*/, 5];
            case 4:
                error_4 = _a.sent();
                console.error('Erro ao obter a URL de autenticação do facebook:', error_4);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var logoutFacebook = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.post('/platforms/logout/facebook', {}, header)];
        }
    });
}); };
// Instagram APIs
export var getInstagramAccounts = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get('/platforms/instagram-accounts', header)]; // Agora sem parâmetro
        }
    });
}); };
// Function to update the cache for a specific agency
export var updateAgencyCache = function (agencyId) { return __awaiter(void 0, void 0, Promise, function () {
    var header, response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, api.post("/update_cache/agency/".concat(agencyId), {}, header)];
            case 3:
                response = _a.sent();
                return [3 /*break*/, 5];
            case 4:
                error_5 = _a.sent();
                console.error("Erro ao atualizar o cache para a ag\u00EAncia ".concat(agencyId, ":"), error_5);
                // Handle error feedback if needed
                throw error_5; // Re-throw error if necessary for caller handling
            case 5: return [2 /*return*/];
        }
    });
}); };
// ✅ NOVOS ENDPOINTS OTIMIZADOS
export var checkGoogleConnectionFull = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get("/platforms/google-connection-full", header)];
        }
    });
}); };
export var checkFacebookConnectionFull = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get("/platforms/facebook-connection-full", header)];
        }
    });
}); };
